import { useState } from "react";
import ModelPage from "../../ModelPage";
import Filter from "../../../../assets/img/skimatic-filter.png";
import QrCode from "../../../../assets/img/qr__ofuro-off-grid.png";

const galleryData = {
    details: {
        items: [
            {
                image: "images/Ofuro_Off_Grid_package.jpg",
                title: "Ofuro Premium",
                subtitle: "PACKAGE",
                text: "A timeless design inspired by Japanese soaking baths, Ofuro hot tubs are perfect for that secluded garden alcove or as a deep, relaxing bathtub.",
            },
            {
                image: "images/Ofuro_Size_1.9.jpg",
                title: "Fibreglass",
                subtitle: "INTERIOR",
                text: "Ofuro Tubs unique makes them especially luxurious to relax in – a throwback to their origins as deep soaking baths. These compact tubs heat up very quickly, and their external stove makes maintenance a breeze. Fill up and drain down times are also reduced.",
            },
        ],
    },
};

const linerColor = [
    {
        id: 1,
        price: 0,
        label: "White",
        color: "#e8e4e4",
        image: "images/white.png",
        modelUID: "9d29f1906deb4cea89539cc1b7229135"
    }
];

const keyFeaturesData = {
    text: "<h2>Key Features</h2><p>Scandinavian thermowood meets an interior shaped for comfort, creating a luxury centrepiece you’ll never want to leave.</p><p>The Premium package consists of 15 wood fired hot tub elements that will cover everything you need for a perfect hot tubbing needs:</p>",
    features: [
        {
            title: "1.9×1.2m fibreglass ofuro hot tub",
            value: "(£2199 value)",
        },
        {
            title: "External heater",
            value: "(£565 value)",
        },
        {
            title: "Stainless steel chimney with a cap",
            value: "(£125 value)",
        },
        {
            title: "304 steel grade upgrade",
            value: "(£150 value)",
        },
        {
            title: "Thermowood exterior cladding",
            value: "(£250 value)",
        },
        {
            title: "Wooden lid",
            value: "(£150 value)",
        },
        {
            title: "High-flow drain tap",
            value: "(£65 value)",
        },
        {
            title: "Stirring paddle",
            value: "(£55 value)",
        },
        {
            title: "Wooden steps",
            value: "(£55 value)",
        },
    ],
    details: {
        items: [
            {
                image: "images/chimney-heat-guard-2.png",
                title: "Chimney Heat Guard",
                subtitle: "FLUE & DRAIN",
                text: "Relax with complete peace of mind. Surrounding the flue, this cost-effective safety add-on prevents injury from accidental contact with the chimney.",
            },
            {
                image: "images/high-flow-drain-tap-deluxe.png",
                title: "High-Flow Drain Tap",
                subtitle: "FLUE & DRAIN",
                text: "Make maintenance easy – you’ll never have to get in a cold tub to drain down with a tapping outside. Also slashes the time to drain your tub, and allows connection to a draining hose (if you’d prefer to not flood the garden).",
            },
        ],
    },
};

const specs = {
    title: "Specifications",
    specs: [
        {
            title: "Capacity:",
            text: "Fits 1-2 adults",
        },
        {
            title: "Package weight:",
            text: "418,8 lbs (190 kg)",
        },
        {
            title: "Height:",
            text: "45 inches (103 cm)",
        },
        {
            title: "External diameter:",
            text: "74,8 inch (190 cm) x 47,2 (120 cm)",
        },
        {
            title: "Depth:",
            text: "36,2 inches (92 cm)",
        },
        {
            title: "Chimney height:",
            text: "105 inches (2,6 m) measured from the ground up",
        },
        {
            title: "Water volume:",
            text: "211,3 gallons (800 l)",
        },
        {
            title: "Heating time:",
            text: "Summer ± 1.5 hrs, Winter ± 2.5 hrs",
        },
        {
            title: "Heater fuel:",
            text: "Softwood/Hardwood",
        },
        {
            title: "Main heater material:",
            text: "Stainless steel (304 grade)",
        },
    ],
    details: {
        items: [
            {
                image: "images/chimney-heat-guard-2.png",
                title: "Chimney Heat Guard",
                subtitle: "FLUE & DRAIN",
                text: "Relax with complete peace of mind. Surrounding the flue, this cost-effective safety add-on prevents injury from accidental contact with the chimney.",
            },
            {
                image: "images/high-flow-drain-tap-deluxe.png",
                title: "High-Flow Drain Tap",
                subtitle: "FLUE & DRAIN",
                text: "Make maintenance easy – you’ll never have to get in a cold tub to drain down with a tapping outside. Also slashes the time to drain your tub, and allows connection to a draining hose (if you’d prefer to not flood the garden).",
            },
        ],
    },
};

const headlineData = {
    title: "Ofuro Off-Grid Package",
    discount: 20,
};

const breadcrumbData = [
    {
        title: "Ofuro Hot Tub",
        active: true,
    },
    {
        title: "Packages",
        active: true,
    },
    {
        title: "Ofuro Off-Grid",
        active: false,
    },
];

const buttonLink = "https://sketchfab.com/models/9d29f1906deb4cea89539cc1b7229135/embed-ar";

const customData = {
	Size: "1.9x1.2m",
	Heater: "External (Standard)",
	"Heater Upgrades": "Stainless steel chimney with a cap",
	Wood: "Thermowood",
	"Liner Type": "Fibreglass",
	Lid: "Wooden",
	"Flue / Drain Add-ons": "High-Flow Drain Tap",
	"Wooden Add-ons": "Stirring Paddle, Wooden Steps",
};

const Package2 = ({backToLabel}) => {
    const [color, setColor] = useState(0)
    const details = {
        base: {
            title: "Ofuro Off-Grid Package",
            price: 3200,
            configuredOptionsTotal: 2050,
            SRP: 3950,
            oldPrice: 3950,
        },
        heater: [
            {
                title: "External heater",
                price: 565,
            },
            {
                title: "Stainless steel chimney with a cap",
                price: 125,
            },
            {
                title: "304-grade stainless steel upgrade",
                price: 150,
            },
        ],
        InteriorAndExterior: [
            {
                title: "Thermowood exterior cladding",
                price: 250,
            },
            {
                title: "Wooden lid",
                price: 150,
            },
            {
                title: `Liner color - ${linerColor[color].label}`,
                price: 0,
            },
            {
                title: "High-flow drain tap",
                price: 65,
            },
            {
                title: "Stirring paddle",
                price: 55,
            },
            {
                title: "Wooden steps",
                price: 55,
            },
            {
                title: "LED underwater lighting (1 LED light)",
                price: 210,
            }
        ],
        accesories: [
            {
                id: 2,
                label: "Submersive Skimatic Filter",
                price: 210,
                name: "wood-treatment",
                image: Filter,
            },
        ],
    };
    
    return (
        <ModelPage
            wooId={1518}
            modelUID="9d29f1906deb4cea89539cc1b7229135"
            qrCode={QrCode}
            videoUrl="https://www.youtube.com/embed/qu8BQjF3E8g"
            backToLabel={backToLabel}
            headlineData={headlineData}
            breadcrumbData={breadcrumbData}
            specs={specs}
            details={details}
            galleryData={galleryData}
            keyFeaturesData={keyFeaturesData}
            color={color}
            linerColor={linerColor}
            setColor={setColor}
            buttonLink={buttonLink}
            customData={customData}
        />
    );
}

export default Package2;
